/* Address, title and card text of the case study. Kept in a file of its own,
   with nothing else in it, because the cards on the home page and in "More
   Case Studies" read it and should not load the page with it. */
export const DS_PATH = "/portfolio-design-system";
export const DS_TITLE = "The Design System Behind This Portfolio";
export const DS_DESCRIPTION =
  "Two AI agents read my prompts their own way. That's why I gave them design tokens with AAA contrast checked on every push.";
export const ARTICLE_SLUG = "accessibility-as-a-build-rule";

/* The case study is told as work in progress. The label sits next to the
   kicker under the title and the log closes Reflections. With every update:
   change the label, add one line on top of the log and check the numbers in
   the TL;DR, the stat tiles and The Outcome. */
export const DS_VERSION = "Version 1 · October 2026";
export const DS_LOG = ["Version 1, October 2026: tokens in three tiers, contrast checked on every push, documentation page drawn from the tokens."];
